import { cn } from "@/lib/utils";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { STATUS, STATUS_TONE, PRIORITY, PRIORITY_TONE } from "@/lib/constants";

export const StatusBadge = ({ status, testid }) => (
  <span data-testid={testid || `status-badge-${status}`} className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold whitespace-nowrap", STATUS_TONE[status])}>{STATUS[status] || status}</span>
);

export const PriorityBadge = ({ priority, testid }) => priority
  ? <span data-testid={testid || `priority-badge-${priority}`} className={cn("inline-flex rounded-full px-2.5 py-0.5 text-xs font-bold", PRIORITY_TONE[priority])}>{PRIORITY[priority]}</span>
  : <span data-testid={testid || "priority-badge-unset"} className="inline-flex rounded-full px-2.5 py-0.5 text-xs font-bold bg-white border border-dashed border-[#B85028] text-[#8A2E14]">Not yet prioritized</span>;

export const PageHead = ({ title, sub, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
    <div>
      <h1 className="text-2xl sm:text-3xl font-black">{title}</h1>
      {sub && <p className="mt-1.5 text-[15px] text-[#605349] max-w-2xl">{sub}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Panel = ({ title, children, className, testid, right }) => (
  <section data-testid={testid} className={cn("rounded-2xl bg-white border border-[#E7DFD5] p-5 sm:p-6", className)}>
    {title && <div className="flex items-center justify-between mb-4"><h2 className="text-lg font-bold">{title}</h2>{right}</div>}
    {children}
  </section>
);

export const sInput = "w-full h-11 rounded-lg border border-[#D9CDBF] bg-white px-3 text-[15px] focus:outline-none focus:ring-2 focus:ring-[#C59B27]";
export const sArea = "w-full min-h-[90px] rounded-lg border border-[#D9CDBF] bg-white px-3 py-2 text-[15px] focus:outline-none focus:ring-2 focus:ring-[#C59B27]";
export const sLabel = "block text-sm font-bold text-[#241D17] mb-1";

export const SButton = ({ className, variant = "primary", ...p }) => (
  <button {...p} className={cn("h-11 px-5 rounded-full text-sm font-bold inline-flex items-center justify-center gap-2 transition-colors duration-150 disabled:opacity-50 focus:outline-none focus:ring-2 focus:ring-[#C59B27]",
    variant === "primary" && "bg-[#4A2E1A] text-white hover:bg-[#362112]",
    variant === "green" && "bg-[#3D6346] text-white hover:bg-[#2D4A34]",
    variant === "ghost" && "border border-[#D9CDBF] text-[#4A2E1A] hover:bg-[#F4EBE4]",
    variant === "danger" && "bg-[#B85028] text-white hover:bg-[#93401F]", className)} />
);

export const Empty = ({ children, testid }) => <p data-testid={testid} className="text-[15px] text-[#605349] py-6 text-center">{children}</p>;

export async function softDelete(kind, id, label) {
  const reason = window.prompt(`Delete ${label}?\nIt will be hidden and kept in "Deleted items" where it can be restored.\nReason (recorded in the audit log):`);
  if (!reason || reason.trim().length < 3) return false;
  try { await api.delete(`/items/${kind}/${id}`, { params: { reason } }); toast.success("Deleted — can be restored from Deleted items"); return true; }
  catch (e) { toast.error(errMsg(e)); return false; }
}
